import { Header, HeaderTitle, pageEntranceSpringValues } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { animated, useSpring } from 'react-spring'

import { useProposerAdjustment } from '../../../../../../hooks/adjustments/policyholder'
import {
  TExtends,
  TKey,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'
import { PolicyholderDisclosureConfig } from '../../../../../../state/configuration'
import { useProposer } from '../../../../../authentication'
import { FormErrors } from '../../../../../formBuilder'

export interface ProposerSectionProps {
  section: PolicyholderDisclosureConfig
  onComplete: () => void
}

const tKey = TKey('pages.disclosure')

export const ProposerSection: FunctionComponent<ProposerSectionProps> = ({
  section,
  onComplete,
}) => {
  const { t } = useWriskTranslation()
  const spring = useSpring(pageEntranceSpringValues)

  const { proposer } = useProposer()

  const onSubmitAdjustment = useProposerAdjustment(onComplete)

  return (
    <animated.div style={spring}>
      <Header>
        <HeaderTitle>{t(tKey('headers', section.id))}</HeaderTitle>
      </Header>
      <FormErrors
        id={section.id}
        key={section.id}
        footerText={section.footerText}
        data={proposer ?? {}}
        config={section.form}
        onSubmit={onSubmitAdjustment.execute}
        loading={onSubmitAdjustment.loading}
        tKey={TExtends(tKey, 'form')}
        t={t}
      />
    </animated.div>
  )
}
